// @flow
import invariant from 'invariant';
import ko from 'rgs-knockout';
import _ from 'lodash/fp';

import type { ExtendKoType } from '../../../core/contracts/utils.flow';

const unwrap = (value: ExtendKoType<any>) => ko.unwrap(value);

const matchByArguments = (paths: string[]) => (...args: *[]) => args.map((item: any, i: number) =>
	_.prop(paths[i])(item));

// todo: fix it

const take = (...paths: string[]) => (target: any, prop: string, descriptor: PropertyDescriptor) => {
	invariant(_.isFunction(descriptor.value), '[Decorator `take`] Should be function');

	return {
		configurable: true,
		get (): Function {
			const bound = descriptor.value.bind(this);

			Object.defineProperty(this, prop, {
				value: bound,
				configurable: this,
				writable: this,
			});


			return _.compose(
				_.spread(bound),
				_.map(unwrap),
				matchByArguments(paths)
			);
		},
	};
};

export default take;
